<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero
      title="Uw persoonlijke account"
      intro="Welkom op uw persoonlijke account. Op deze manier willen we u extra begeleiden en ondersteunen bij het samenstellen van de uitvaart."
    />

    <!-- Navigation cards -->
    <v-row
      justify="center"
      class="mb-8 pb-8 account-cards"
    >
      <v-col
        v-for="(card, index) in cards"
        class="center px-2"
        cols="12"
        md="6"
        lg="5"
        :key="index"
      >
        <router-link
          class="account-card"
          :to="card.to"
        >
          <div
            class="account-card-icon"
            :class="'account-card-icon--' + card.theme"
          >
            <v-icon
              color="white"
              size="28"
            >
              {{ card.icon }}
            </v-icon>
          </div>
          <h2
            class="account-card-title"
            :class="'account-card-title--' + card.theme"
          >
            {{ card.title }}
          </h2>
          <p class="account-card-description">
            {{ card.description }}
          </p>
          <v-icon
            class="account-card-arrow"
            color="#bbb"
            size="24"
          >
            mdi-arrow-right
          </v-icon>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authenticationMixin from '@/mixins/authenticationMixin'
import PageHero from '@/components/PageHero.vue'

export default {
  name: 'AccountComponent',
  components: {
    PageHero
  },
  mixins: [
    authenticationMixin
  ],
  data () {
    return {
      cards: [
        {
          title: 'Uitvaart',
          description: 'Bekijk ontvangen condoleances. Kies persoonlijke muziek en teksten. We zorgen samen met u voor een unieke, persoonlijke en stijlvolle uitvaart.',
          icon: 'mdi-heart-outline',
          theme: 'gold',
          to: 'Uitvaart'
        },
        {
          title: 'Administratie',
          description: 'Alle documenten voor de administratieve afhandelingen op één plaats. We stellen u een uitgebreide uitvaartbrochure ter beschikking.',
          icon: 'mdi-file-document-outline',
          theme: 'secondary',
          to: 'Administratie'
        }
      ]
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
  }
}
</script>

<style scoped>
.account-cards {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
}

.account-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 32px;
  border: 1px solid #e8e4dc;
  border-radius: 10px;
  background-color: #fdfcfa;
  text-decoration: none;
  color: inherit;
  height: 100%;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.account-card:hover {
  background-color: #FBF7EE;
  border-color: #DEC067;
}

.account-card-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.account-card-icon--gold {
  background-color: #907322;
}

.account-card-icon--secondary {
  background-color: #424E58;
}

.account-card-title {
  font-size: 22px;
  font-weight: 500;
  padding: 0;
  margin: 0 0 12px 0;
}

.account-card-title--gold {
  color: #907322;
}

.account-card-title--secondary {
  color: #424E58;
}

.account-card-description {
  font-size: 15px;
  color: #6b6b6b;
  line-height: 1.7;
  flex: 1;
  padding: 0;
}

.account-card-arrow {
  margin-top: 16px;
  transition: transform 0.2s ease;
}

.account-card:hover .account-card-arrow {
  transform: translateX(4px);
}
</style>
